import { useTranslation } from 'react-i18next'
import React from 'react'

import { getNonComplianceStatusColor } from '../_helpers/getStatusColor'
import Tag from '../../../components/presentation/Tag'

const StatusTag = ({ name, ...props }) => {
  const { t } = useTranslation()
  if (!name) return false

  const color = getNonComplianceStatusColor(name)
  const label = t('status.' + name)

  return <Tag label={label} bgColor={color} {...props} />
}

export default StatusTag
